import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WebService\SaveShutterStockToGalleyController::__invoke
* @see app/Http/Controllers/WebService/SaveShutterStockToGalleyController.php
* @route '/api/webservice/shutterstock/{id}/save-to-gallery'
*/
const SaveShutterStockToGalleyController = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SaveShutterStockToGalleyController.url(args, options),
    method: 'get',
})

SaveShutterStockToGalleyController.definition = {
    methods: ["get","head"],
    url: '/api/webservice/shutterstock/{id}/save-to-gallery',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WebService\SaveShutterStockToGalleyController::__invoke
* @see app/Http/Controllers/WebService/SaveShutterStockToGalleyController.php
* @route '/api/webservice/shutterstock/{id}/save-to-gallery'
*/
SaveShutterStockToGalleyController.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return SaveShutterStockToGalleyController.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WebService\SaveShutterStockToGalleyController::__invoke
* @see app/Http/Controllers/WebService/SaveShutterStockToGalleyController.php
* @route '/api/webservice/shutterstock/{id}/save-to-gallery'
*/
SaveShutterStockToGalleyController.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SaveShutterStockToGalleyController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebService\SaveShutterStockToGalleyController::__invoke
* @see app/Http/Controllers/WebService/SaveShutterStockToGalleyController.php
* @route '/api/webservice/shutterstock/{id}/save-to-gallery'
*/
SaveShutterStockToGalleyController.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SaveShutterStockToGalleyController.url(args, options),
    method: 'head',
})

export default SaveShutterStockToGalleyController